import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getUserMessages } from "../../service/UserApi";
import { Loading } from "../../components/shared";
import { formatSecondsToUserFriendlyDateTime } from "../../utils/Utilities";
const MessagesDetails = () => {
  const user = useSelector((state) => state.user);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMessages = async () => {
      if (!user.email) return;

      setLoading(true);
      try {
        const response = await getUserMessages(user.email);
        setMessages(response?.messages || []);
      } catch (error) {
        console.error("Error fetching messages:", error);
        setMessages([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, [user.email]);

  if (loading) return <Loading />;
  if (!messages.length) return <p>செய்திகள் இல்லை</p>;

  const sortedMessages = [...messages].sort(
    (a, b) => b.createdAt._seconds - a.createdAt._seconds
  );

  return (
    <div style={pageStyle}>
      <h4 style={{ marginBottom: "16px" }}>செய்திகள்</h4>

      <div style={containerStyle}>
        {sortedMessages.map((msg, index) => (
          <div key={index} style={messageCardStyle}>
            <div style={titleStyle}>{msg.title || ""}</div>
            <div style={bodyStyle}>{msg.body}</div>
            <div style={footerStyle(msg.read)}>
              அனுப்பப்பட்டது: 🕒 {formatSecondsToUserFriendlyDateTime(msg.createdAt._seconds)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// ✅ Styles
const pageStyle = {
  padding: "16px",
};

const containerStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "16px",
};

const messageCardStyle = {
  background: "#fff",
  border: "1px solid #ddd",
  borderRadius: "8px",
  padding: "12px 16px",
  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
};

const titleStyle = {
  fontWeight: "bold",
  fontSize: "16px",
  marginBottom: "6px",
};

const bodyStyle = {
  fontSize: "15px",
  marginBottom: "6px",
  whiteSpace: "pre-wrap",
};

const footerStyle = () => ({
  fontSize: "13px",
  fontStyle: "italic",
  color: "#666",
});

export default MessagesDetails;
